import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL;

export const getAllUserCourse = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/userReport`, { params: reqData });
};
export const getAllUserReportCount = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/userReportCount`, { params: reqData });
};
export const getAssignCompleteCourseReport = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/assignCompleteCourseReport`, { params: reqData });
};
export const getLeaderBoardData = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/orgUserRank`, { params: reqData });
};
export const getAllUserReport = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/userReports`, { params: reqData });
};
export const getThisCourse = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/courseAnalysis`, { params: reqData });
};
export const getUserCourses = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/getUserCourses`, { params: reqData });
};
export const getUserOverview = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/getUserOverview`, { params: reqData });
};
export const getCourseCertificate = (reqData: Object) => {
  return axios.get(`${API_URL}userCourse/getUserCourses`, { params: reqData });
};
export const getAllCourse = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/courseReports`, { params: reqData });
};
export const getReportCard = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/orgUsersCount`, { params: reqData });
};
export const getReportTable = (reqData: Object) => {
  return axios.get(`${API_URL}analysis/orgUsersList`, { params: reqData });
};
export const getCourseCount = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/orgCourseCount`, { params: reqData });
};
export const getCourseList = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/orgCoursesList`, { params: reqData });
};
export const getUserCoursesList = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/getUserCoursesList`, { params: reqData });
};
export const getUserDashBoard = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/userReportOverview`, { params: reqData });
};
export const getOrgAssessmentCount = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/orgAssessmentCount`, { params: reqData });
};
export const getAssessmentOverview = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/assessmentOverview`, { params: reqData });
};
export const getOrgAssessmentUsers = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/orgAssessmentUsers`, { params: reqData });
};
export const getAssessmentUserList = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/assessmentUserList`, { params: reqData });
};
export const getCourseAssessmentList = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/getCourseAssessmentList`, { params: reqData });
};
export const getUserCertificates = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/getUserCertificatesList`, { params: reqData });
};
export const getCourseUserList = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/getCourseUserList`, { params: reqData });
};
export const getCourseAnalysis = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/courseAnalysis`, { params: reqData });
};
export const getWeeklyReport = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/weeklyReport`, { params: reqData });
};
export const getCourseProgressReport = async (reqData: any, operation: string) => {
  return axios.get(`${API_URL}analysis/weeklyReport/${operation}`, { params: reqData });
};
export const getUserReportAsFile = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/userReportFile/download`, { params: reqData });
};
export const getMeetingAnalysis = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/userReportMeeting`, { params: reqData });
};
export const getUserAnalysisFile = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/userAnalysisFile/download`, { params: reqData });
};
export const getUserCourseProgressReportAsFile = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/userCourseReportFile/download`, { params: reqData });
};
export const getMeetingReportAsFile = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/meetingReportFile/download`, { params: reqData });
};
export const getAssessmentReportAsFile = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/assessmentReportFile/download`, { params: reqData });
};
export const getAssignmentReportAsFile = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/assignmentReportFile/download`, { params: reqData });
};
export const getAssessorTotalCount = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/assessor/totalCount`, { params: reqData });
};
export const getAssessorList = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/assessor/users`, { params: reqData });
};
export const getAssessorDetails = async (reqData: any) => {
  return axios.get(`${API_URL}analysis/assessorDetails`, { params: reqData });
};
